import { jsx } from 'react/jsx-runtime';
import { Spinner } from '../../../../spinner/Spinner.mjs';

const LOADING_INDICATOR_SIZE_RECORD = {
  xsmall: 14,
  small: 18,
  default: 20,
  large: 22,
  xlarge: 22
};
function LoadingIndicator({
  color,
  danger = false,
  size = "default",
  variant,
  ...props
}) {
  const indicatorColor = variant === "solid" ? "white" : danger ? "orange" : color;
  return /* @__PURE__ */ jsx(
    Spinner,
    {
      color: indicatorColor,
      size: LOADING_INDICATOR_SIZE_RECORD[size],
      ...props
    }
  );
}

export { LoadingIndicator };
//# sourceMappingURL=LoadingIndicator.mjs.map
